import React from 'react'

export default function () {
	return (
		<svg width="12px" height="20px" viewBox="0 0 12 20">
			<path d="M10.2,0 L1.8,0 C0.80625,0 0,0.83984375 0,1.875 L0,18.125 C0,19.1601562 0.80625,20 1.8,20 L10.2,20 C11.19375,20 12,19.1601562 12,18.125 L12,1.875 C12,0.83984375 11.19375,0 10.2,0 Z M6,18.75 C5.33625,18.75 4.8,18.1914062 4.8,17.5 C4.8,16.8085938 5.33625,16.25 6,16.25 C6.66375,16.25 7.2,16.8085938 7.2,17.5 C7.2,18.1914062 6.66375,18.75 6,18.75 Z M10.2,14.53125 C10.2,14.7890625 9.9975,15 9.75,15 L2.25,15 C2.0025,15 1.8,14.7890625 1.8,14.53125 L1.8,2.34375 C1.8,2.0859375 2.0025,1.875 2.25,1.875 L9.75,1.875 C9.9975,1.875 10.2,2.0859375 10.2,2.34375 L10.2,14.53125 Z" />
		</svg>
	)
}
